<template>
  <div class="share-url">
    <h1>{{ $t('menu_share_url') }}</h1>
    <p>{{ $t('share_url.description') }}</p>

    <div class="share-link-container">
      <v-text-field
        v-model="shareURL"
        :label="$t('share_url.subtitle')"
        readonly
      ></v-text-field>
      <v-btn @click="copyToClipboard">{{ $t('share_url.copy_button') }}</v-btn>
    </div>

    <p v-if="copySuccess">{{ $t('share_url.copy_success') }}</p>
  </div>
</template>

<script>
export default {
  name: 'ShareURL',
  data() {
    return {
      shareURL: '', // ここで生成したURLを保持
      copySuccess: false
    }
  },
  mounted() {
    this.generateShareURL();
  },
  methods: {
    // ローカルストレージから user_id を取得してURLを生成
    generateShareURL() {
      const storedData = JSON.parse(localStorage.getItem('no-foodloss'));
      const userId = storedData?.user_info?.user_id;

      if (userId) {
        this.shareURL = `https://${window.location.host}?user_id=${userId}`;
      } else {
        console.error('User ID not found in local storage.');
      }
    },
    // クリップボードにURLをコピー
    copyToClipboard() {
      navigator.clipboard.writeText(this.shareURL).then(() => {
        this.copySuccess = true;
      }).catch(err => {
        console.error('Could not copy text: ', err);
      });
    }
  }
}
</script>
